import React, { useEffect, useRef, useState } from 'react';
import "./styles.css";
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import FolderSvg from "../../Images/folder.svg";
import PlusSquared from "../../Images/PlusSquared.svg";
import { M_URL, MAIN_URL } from '../../constants';
import { toast } from 'react-toastify';
import api from '../../Components/RefreshToken/RefreshToken';
import SpeakerNotesBlock from './speakerNotes/SpeakerNotesBlock';
import SpeakerNotesStep2Bar from './speakerNotes/SpeakerNotesStep2Bar';
import { SpeakerNotesMeta } from './speakerNotes/common';
import { applySpeakerNotes, baseTextsFromResponse, buildSources, markFromTxt, sourceState } from './speakerNotes/apply';

const NewCourse = ({ isOpenGenerate, openStatus }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [fileError, setFileError] = useState(false);
    const [TOKEN] = useState(localStorage.getItem("admin_token"));

    const [description, setDescription] = useState("");
    const [introduction, setIntroduction] = useState("");
    const [formData, setFormData] = useState({
        text: '',
        file: null
    });
    const [fileName, setFileName] = useState('');
    const [language, setLanguage] = useState('');
    const [fileURL, setFileURL] = useState('');
    const replaceVid = sessionStorage.getItem("replaceVid");
    const [avatar, setAvatar] = useState([]);
    const [isAvatar, setIsAvatar] = useState(false);
    const [avatarId, setAvatarId] = useState("");
    const [requiredAvatar, setRequiredAvatar] = useState(true);
    const [speechText, setSpeechText] = useState(false);
    const [speeechResult, setSpeechResult] = useState(null);
    const [texts, setTexts] = useState([]);
    const [pdfFileInspect, setPdfFileInspect] = useState(false);
    const [selectedAvatar, setSelectedAvatar] = useState("Select an Avatar");
    // Spiker matnlari (TXT): 1-qadamda yuklangan fayl, 2-qadamda har sahifa matnining manbai va natija xabari
    const [speakerNotes, setSpeakerNotes] = useState(null);
    const [textSources, setTextSources] = useState({});
    const [notesReport, setNotesReport] = useState(null);
    const speakerNotesRef = useRef(null);
    speakerNotesRef.current = speakerNotes;

    // Auth header helper
    const authHeader = () => ({
        'accept': 'application/json',
        'Authorization': `Bearer ${TOKEN}`
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.file) {
            setFileError(true);
            toast.warn("Please upload a file.");
            return;
        } else {
            setFileError(false);
        }

        if (!avatarId) {
            toast.warn("Please select Avatar");
            setRequiredAvatar(false);
            return;
        } else {
            setRequiredAvatar(true);
        }

        setLoading(true);
        localStorage.setItem("textOfVideo", description);

        const payload = {
            task_id: speeechResult?.task_id,
            language: language,
            avatar_id: avatarId,
            texts: texts,
        };

        axios.post(`${M_URL}/generate-video`, payload, {
            headers: authHeader()
        })
            .then(({ data }) => {
                if (data?.status === "pending") {
                    localStorage.setItem("taskId", data?.task_id);
                    localStorage.setItem("status", "processing");
                    if (replaceVid) {
                        isOpenGenerate(false);
                        openStatus(true);
                    } else {
                        navigate("/status");
                    }
                } else {
                    toast.error(`Error generating video: ${data}`);
                }
            }).catch(error => {
                if (error.response?.status === 429) {
                    toast.warn(`${error.response.data.detail}`);
                } else if (error.response?.status === 401) {
                    toast.error("Avtorizatsiya xatosi. Iltimos qayta login qiling.");
                } else {
                    toast.error(`Error: ${error.message}`);
                }
            }).finally(() => {
                setLoading(false);
            });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.type !== "application/pdf") {
            setPdfFileInspect(true);
            e.target.value = "";
            return;
        }

        setFileName(file.name);
        setFileURL(URL.createObjectURL(file));
        setPdfFileInspect(false);
        setFormData(prev => ({ ...prev, file: file }));
    };

    useEffect(() => {
        if (!language) return;
        api.get(`${MAIN_URL}/management/mentor/avatar`, {
            headers: {
                ...authHeader(),
            },
            params: { language: language }
        }).then((res) => {
            setAvatar(res.data || []);
        }).catch((err) => {
            console.log(err);
        });
    }, [language, TOKEN]);

    const handleAvatarSelect = (item) => {
        setSelectedAvatar(`${item.mentor?.first_name} ${item.mentor?.last_name}`);
        setIsAvatar(false);
        setAvatarId(item.id);
        setRequiredAvatar(true);
    };

    const generateSpeechText = async () => {
        const formDataNew = new FormData();
        formDataNew.append("file", formData.file);
        formDataNew.append("text", "speech_text");
        formDataNew.append("language", language);
        formDataNew.append("introduction", introduction);

        const form = document.getElementById("generateId");
        if (!form.checkValidity()) {
            form.reportValidity();
            setLoading(false);
            return;
        }

        try {
            const response = await axios.post(
                `${M_URL}/generate-speech-text`,
                formDataNew,
                {
                    headers: {
                        ...authHeader(),
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            setSpeechResult(response.data);

            if (response.data.speech_text && response.data.speech_text.length > 0) {
                setTexts(response.data.speech_text);
            } else {
                setTexts(
                    Array.from({ length: response.data.num_pages }, (_, index) => ({
                        slide_number: index + 1,
                        speech_text: "",
                    }))
                );
            }

            setLoading(false);
            setSpeechText(true);
        } catch (error) {
            setLoading(false);
            if (error.response?.status === 401) {
                toast.error("Avtorizatsiya xatosi. Iltimos qayta login qiling.");
            } else {
                toast.error("Speech text generatsiya qilishda xatolik yuz berdi.");
            }
        }
    };

    const submitSpeechText = (e) => {
        e.preventDefault();
        setLoading(true);
        generateSpeechText();
    };

    useEffect(() => {
        if (!speeechResult) return;

        if (speeechResult.speech_text?.length > 0) {
            setTexts(speeechResult.speech_text);
        } else {
            setTexts(
                Array.from(
                    { length: speeechResult.num_pages || 0 },
                    (_, index) => ({
                        slide_number: index + 1,
                        speech_text: ""
                    })
                )
            );
        }
    }, [speeechResult]);

    // Yuqoridagi effektdan keyin ishlaydi: TXT bo'lsa, fayldagi sahifalar server matni ustiga qo'yiladi
    // (faylda yo'q sahifalarda server matni qoladi). Har sahifa matnining manbai belgilanadi.
    useEffect(() => {
        if (!speeechResult) return;
        const notes = speakerNotesRef.current;
        const result = applySpeakerNotes(baseTextsFromResponse(speeechResult), notes?.pages);
        if (notes) {
            setTexts(result.texts);
            setNotesReport({ filled: result.applied.length, ignored: result.missing });
        }
        setTextSources(buildSources(result.texts, result.applied));
    }, [speeechResult]);

    // 2-qadam: "TXT'dan to'ldirish" tasdiqlangandan keyin
    const handleNotesReplace = (pages) => {
        const result = applySpeakerNotes(texts, pages);
        setTexts(result.texts);
        setTextSources((prev) => markFromTxt(prev, result.texts, result.applied));
        setNotesReport({ filled: result.applied.length, ignored: result.missing });
    };

    return (
        <>
            <AnimatePresence mode="wait">
                <motion.div
                    initial={{ opacity: 0, transform: "translateX(20%)", maxHeight: "100vh", overflow: "auto", marginTop: "30px", marginBottom: "30px" }}
                    animate={{ opacity: 1, transform: "translateX(0)" }}
                    exit={{ opacity: 0, transform: "translateX(-20%)" }}
                    transition={{ duration: 0.5 }}
                    className="hide-scroll"
                >
                    {speechText ? (
                        /* SPEECH TEXT EDIT QILISH REJIMI */
                        <div className="overflow-container">
                            <SpeakerNotesStep2Bar
                                texts={texts}
                                sources={textSources}
                                report={notesReport}
                                pageCount={speeechResult?.num_pages || texts.length}
                                onReplace={handleNotesReplace}
                            />
                            {texts.map((item, index) => (
                                <div key={item.slide_number}>
                                    <textarea
                                        value={`${index + 1}. ${item.speech_text}`}
                                        className="speech-textarea"
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/^\d+\.\s*/, "");
                                            const updatedTexts = [...texts];
                                            updatedTexts[index] = {
                                                ...updatedTexts[index],
                                                speech_text: value,
                                            };
                                            setTexts(updatedTexts);
                                        }}
                                        required
                                    />
                                    <SpeakerNotesMeta
                                        state={sourceState(item, textSources[item.slide_number])}
                                        length={(item.speech_text || "").length}
                                    />
                                </div>
                            ))}

                            <button
                                className="add-btn"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? "Loading..." : "Generated Video"}
                            </button>
                        </div>
                    ) : (
                        /* ASOSIY GENERATSIYA FORMASI */
                        <form id='generateId' className="container" onSubmit={submitSpeechText}>
                            <h1>Video generating</h1>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%", paddingTop: "10px" }}>

                                {/* Fayl yuklash qismi */}
                                <div className="add-file-container addFile-generate" style={{ marginBottom: "0px", width: "100%" }}>
                                    <label className={`add-file ${fileError ? "error-border" : ""}`}>
                                        <span>Add file pdf</span>
                                        <img src={PlusSquared} alt="" />
                                        <input
                                            required
                                            type="file"
                                            name="pdf"
                                            accept=".pdf"
                                            style={{ display: "none" }}
                                            onChange={handleFileChange}
                                        />
                                    </label>
                                    {pdfFileInspect && (
                                        <span style={{ color: "red", width: "fit-content" }}>Only PDF files can be uploaded!</span>
                                    )}
                                    {fileName && fileURL && (
                                        <div className='uploaded-file-container width-file'>
                                            <img src={FolderSvg} alt="" />
                                            <a href={fileURL} target="_blank" rel="noopener noreferrer">
                                                {fileName.length > 12 ? fileName.slice(0, 12) + "..." : fileName}
                                            </a>
                                        </div>
                                    )}
                                </div>

                                {/* Tilni tanlash */}
                                <div style={{ width: "300px", marginLeft: "30px" }}>
                                    <select required onChange={(e) => { setLanguage(e.target.value); setAvatarId(""); setSelectedAvatar("Select a Avatar") }} name="language">
                                        <option value="" hidden>Select a language</option>
                                        <option value="en">English</option>
                                        <option value="uz">Uzbek</option>
                                        <option value="ru">Russian</option>
                                    </select>
                                </div>

                                {/* Avatarni tanlash */}
                                <div className={`${requiredAvatar ? 'select-avatar-block' : "select-avatar-block noSelect"}`} style={{ width: "300px" }}>
                                    <div onClick={() => setIsAvatar(x => !x)} className='select-avatar-list'>
                                        {selectedAvatar} <i style={{ marginLeft: "130px" }} className="ri-arrow-down-s-line positionIcon"></i>
                                    </div>
                                    {isAvatar && (
                                        <ul className="mentor-avatar-list">
                                            {avatar.length === 0 && (
                                                <li className='avatar-item show'>No Avatar</li>
                                            )}
                                            {avatar.map((item, index) => (
                                                <li
                                                    className='avatar-item'
                                                    key={index}
                                                    onClick={() => handleAvatarSelect(item)}
                                                >
                                                    {item.mentor?.first_name} {item.mentor?.last_name}
                                                    <img className='avatar-image' src={`${MAIN_URL}/${item.photo}`} alt="avatar" />
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>

                            <textarea
                                value={introduction}
                                onChange={(e) => setIntroduction(e.target.value)}
                                className="add-lesson-textarea"
                                style={{ height: "80px", marginTop: "20px" }}
                                placeholder="Enter introduction text (optional)..."
                            />
                            <SpeakerNotesBlock
                                pdfFile={formData.file}
                                pdfName={fileName}
                                value={speakerNotes}
                                onChange={setSpeakerNotes}
                            />
                            {/* <textarea
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                className="add-lesson-textarea"
                                placeholder="Enter video description..."
                                required
                            /> */}
                            <button
                                type="submit"
                                className="add-btn"
                                disabled={loading}
                            >
                                {loading ? "Loading..." : "Generate Video"}
                            </button>
                        </form>
                    )}
                </motion.div>
            </AnimatePresence>
        </>
    );
};

export default NewCourse;